import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import ReactDOM from "react-dom";
import Typography from "@mui/material/Typography";

type Props = {
  title: string;
};

const PageTitle = (props: Props) => {
  const titlePortal = document.getElementById("mobile-title-portal");

  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      margin: theme.spacing(0, 0, 1, 0),
    },
  }));

  const classes = useStyles();

  const renderMobileTitle = () => {
    if (!titlePortal) throw Error("no add portal");

    return ReactDOM.createPortal(<div>{props.title}</div>, titlePortal);
  };

  if (titlePortal) {
    return renderMobileTitle();
  }

  return (
    <Typography variant="body1" component="span" className={classes.root}>
      {props.title}
    </Typography>
  );
};

export { PageTitle };
